<template>
  <div
    class="modal fade"
    id="add_sales_rep_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="rep_modal_title"
    aria-hidden="true"
    ref="portal"
    :data-backdrop="showBackdrop"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="rep_modal_title">
            {{ modalMode ? "Edit Sales Rep" : "Create a new Sales Rep" }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            id="closeRepModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group row" :class="{ validated: has_errors }">
            <div class="col">
              <label>
                Name:
                <span class="required">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': modal_errors.name }"
                placeholder="Enter user name and lastname"
                v-model="modal_name"
                ref="inputName"
              />
              <div class="error invalid-feedback" v-if="modal_errors.name">
                {{ modal_errors.name }}
              </div>
              <span class="form-text text-muted"
                >Enter user name and lastname.</span
              >
            </div>
          </div>
          <div class="form-group row" :class="{ validated: has_errors }">
            <div class="col">
              <label>
                Email:
                <span class="required">*</span>
              </label>
              <input
                type="email"
                class="form-control"
                :class="{ 'is-invalid': modal_errors.email }"
                placeholder="Enter user email"
                v-model="modal_email"
              />
              <div class="error invalid-feedback" v-if="modal_errors.email">
                {{ modal_errors.email }}
              </div>
              <span class="form-text text-muted">Enter user email.</span>
            </div>
          </div>
          <div class="form-group row" :class="{ validated: has_errors }">
            <div class="col">
              <label for="phone"> Phone Number (optional): </label>
              <div class="text-center mb-2">
                <div id="otp" class="flex justify-center">
                  <input
                    class="
                      mr-2
                      text-center
                      form-control form-control-solid
                      rounded
                      focus:border-blue-400 focus:shadow-outline
                    "
                    type="text"
                    id="first"
                    ref="modal_phone_1"
                    maxlength="3"
                    :value="modal_phone_1"
                    @input="handlePhoneNumber(1, $event.target.value, $event)"
                  />
                  <input
                    class="
                      mr-2
                      text-center
                      form-control form-control-solid
                      rounded
                      focus:border-blue-400 focus:shadow-outline
                    "
                    type="text"
                    id="second"
                    ref="modal_phone_2"
                    maxlength="3"
                    :value="modal_phone_2"
                    @input="handlePhoneNumber(2, $event.target.value, $event)"
                  />
                  <input
                    class="
                      mr-2
                      text-center
                      form-control form-control-solid
                      rounded
                      focus:border-blue-400 focus:shadow-outline
                    "
                    type="text"
                    id="third"
                    ref="modal_phone_3"
                    :value="modal_phone_3"
                    @input="handlePhoneNumber(3, $event.target.value, $event)"
                  />
                </div>
              </div>
              <!-- Add Extension -->
              <span
                class="form-text text-muted my-2 show-extension-switch"
                v-if="!showAddExtension"
                @click="showAddExtension = true"
                >Add Extension</span
              >
              <label v-else>
                Extension:
                <input
                  class="
                    mt-2
                    text-center
                    form-control form-control-solid
                    rounded
                    focus:border-blue-400 focus:shadow-outline
                  "
                  type="text"
                  id="phone-ext"
                  v-model="modal_phone_extension"
                />

                <span
                  class="text-muted show-extension-switch"
                  @click="showAddExtension = false"
                  >Hide extension</span
                >
              </label>
              <span class="form-text text-muted">Enter user phone number.</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-brand"
            data-dismiss="modal"
          >
            Close
          </button>
          <button type="button" class="btn btn-brand" @click="postModal()">
            Save changes
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import PhoneMaskInput from "vue-phone-mask-input";

export default {
  name: "SalesRepsModal",
  props: [
    "modalMode",
    "modalName",
    "modalEmail",
    "modalUserId",
    "modalPhone",
    "showBackdrop",
  ],

  components: {
    // PhoneMaskInput,
  },

  data() {
    return {
      modal_name: this.modalName,
      modal_email: this.modalEmail,
      modal_phone: this.modalPhone,
      modal_errors: {},
      modal_user_id: this.modalUserId,
      modal_phone_1: "",
      modal_phone_2: "",
      modal_phone_3: "",
      modal_phone_extension: "Ext. ",
      showAddExtension: false,
    };
  },

  computed: {
    has_errors() {
      return Object.keys(this.modal_errors).length > 0;
    },

    phoneNumber() {
      const phone = `(${this.modal_phone_1}) ${this.modal_phone_2}-${this.modal_phone_3}`;

      return this.showAddExtension && this.modal_phone_extension
        ? `${phone}  ${this.modal_phone_extension}`
        : phone;
    },
  },

  methods: {
    checkForm: function () {
      this.modal_errors = {};
      //email
      if (!this.modal_email) {
        this.modal_errors.email = "Email required.";
      } else if (!this.validEmail(this.modal_email)) {
        this.modal_errors.email =
          "Valid email address required, e.g. mail@example.com";
      } else if (this.modal_email.length > 200) {
        this.modal_errors.email = "Email too long.";
      }

      if (!this.modal_name) {
        this.modal_errors.name = "Name required.";
      } else if (this.modal_name.length > 200) {
        this.modal_errors.name = "Name too long.";
      }

      if (this.modal_phone?.length > 50) {
        this.modal_errors.phone = "Phone Number too long.";
      }

      if (!Object.keys(this.modal_errors).length) {
        return true;
      }
      this.$store.dispatch("showToast", {
        txt: "Please verify your information is correct",
        type: "error",
      });
      return false;
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    postModal() {
      if (this.checkForm()) {
        const params = {
          modalName: this.modal_name,
          modalEmail: this.modal_email,
          modalUserId: this.modal_user_id,
        };

        if (this.phoneNumber?.length >= 14) {
          params["modalPhone"] = this.phoneNumber;
        }
        this.$emit("postModal", params);
      }
    },
    handlePhoneNumber(i, newValue) {
      const oldValue = this[`modal_phone_${i}`];

      const focusOnInput = (i) => {
        this.$nextTick(() => {
          this.$refs[`modal_phone_${i}`].focus();
        });
      };

      //Check if we have to move on to the next input
      const FIRST_INPUT_LENGTH = 3;
      const SECOND_INPUT_LENGTH = 3;
      const THIRD_INPUT_LENGTH = 4;

      //Move to previuos input text if the new value is empty
      if (!newValue && i !== 1) {
        focusOnInput(i - 1);
        this[`modal_phone_${i}`] = newValue;
        return true;
      }

      switch (i) {
        case 1:
          if (newValue.length >= FIRST_INPUT_LENGTH) {
            this[`modal_phone_${i}`] = newValue;
            focusOnInput(2);
          } else if (newValue.length <= FIRST_INPUT_LENGTH) {
            this[`modal_phone_${i}`] = newValue;
          } else {
            this[`modal_phone_${i}`] = oldValue;
          }
          break;
        case 2:
          if (newValue.length >= SECOND_INPUT_LENGTH) {
            this[`modal_phone_${i}`] = newValue;
            focusOnInput(3);
          } else if (newValue.length <= SECOND_INPUT_LENGTH) {
            this[`modal_phone_${i}`] = newValue;
          } else {
            this[`modal_phone_${i}`] = oldValue;
          }
          break;
        case 3:
          //Do not allow third input to go up to 4 characters
          if (newValue.length <= THIRD_INPUT_LENGTH) {
            this[`modal_phone_${i}`] = newValue;
          } else {
            this[`modal_phone_${i}`] = oldValue;
          }
          break;
        default:
          this[`modal_phone_${i}`] = oldValue;
      }
    },
  },

  watch: {
    $props: {
      handler() {
        this.modal_name = this.modalName;
        this.modal_email = this.modalEmail;
        this.modal_user_id = this.modalUserId;

        const phoneExtension =
          this.modalPhone?.indexOf("Ext") > -1
            ? this.modalPhone?.split("Ext")[1]
            : "";

        this.modal_phone_extension = "Ext " + phoneExtension;
        this.showAddExtension = !!phoneExtension;

        const phoneWithoutExtension = this.modalPhone?.replace(
          /\s+Ext\.\s+/g,
          ""
        );

        const phoneWithoutSpecialChars = phoneWithoutExtension?.replace(
          /[- )(]/g,
          ""
        );


        this.modal_phone_1 = phoneWithoutSpecialChars?.substring(0, 3);
        this.modal_phone_2 = phoneWithoutSpecialChars?.substring(3, 6);
        this.modal_phone_3 = phoneWithoutSpecialChars?.substring(6, 10);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  .phone-mask-container {
    input {
      width: 30%;
    }
  }
  .show-extension-switch {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  &::v-deep .wrraper-example {
    position: relative;
    .flag {
      position: absolute;
      top: 1px;
      left: 25%;
    }
  }
}
</style>
